import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';

@Component
export default class WriteTitle extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @PropSync('value', { type: Object }) textModel!: mail.WriteEmailData;
}
